import { render, staticRenderFns } from "./PacketCardSinglePoint.vue?vue&type=template&id=8a82e200&scoped=true&"
import script from "./PacketCardSinglePoint.vue?vue&type=script&lang=ts&"
export * from "./PacketCardSinglePoint.vue?vue&type=script&lang=ts&"
import style0 from "./PacketCardSinglePoint.vue?vue&type=style&index=0&id=8a82e200&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a82e200",
  null
  
)

export default component.exports